<template>
    <modal
        class="is-narrow"
        v-bind:title="__('Are you sure?')"
        v-bind:is-open="open"
        v-on:close-modal="close"
    >
        <template v-slot:body>
            <p
                class="has-text-center"
                v-html="
                    __(
                        'Are you sure you want to delete this video?<br />This action cannot be undone.'
                    )
                "
            ></p>
        </template>
        <template v-slot:footer>
            <div class="has-padding-t10">
                <div class="columns">
                    <div class="column">
                        <btn
                            class="is-block"
                            type="cancel"
                            v-html="__('Cancel')"
                            v-on:click="close"
                        >
                        </btn>
                    </div>
                    <div class="column">
                        <btn
                            class="is-block"
                            type="error"
                            v-html="__('Delete')"
                            v-on:click="deleteVideo"
                        >
                        </btn>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import { Btn, Control, Modal } from '@teamfurther/cinderblock';

export default {
    components: {
        Btn,
        Control,
        Modal
    },
    methods: {
        close: function() {
            this.$emit('close');
        },
        deleteVideo: function() {
            this.$emit('delete', this.videoId);
        }
    },
    props: {
        open: {
            required: true
        },
        videoId: {
            required: true
        }
    }
};
</script>
